import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class AfericaoServicoInicialService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getAfericaoServicosIniciais(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterText: string,
    filterData: any,
    statusFilter: any
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('nomeNumeroContrato', filterText || '')
      .set('nomeEscopo', filterData?.value?.nomeEscopo || '')
      .set('nomeTipoServico', filterData?.value?.nomeTipoServico || '')
      .set('parametroDesempenho', filterData?.value?.parametroDesempenho || '')

    if (filterData?.value?.inicioPrazo) {
      params = params.set('inicioPrazo', moment(filterData?.value?.inicioPrazo).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.fimPrazo) {
      params = params.set('fimPrazo', moment(filterData?.value?.fimPrazo).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.dataAfericaoInicio) {
      params = params.set('dataAfericaoInicio', moment(filterData?.value?.dataAfericaoInicio).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.dataAfericaoFim) {
      params = params.set('dataAfericaoFim', moment(filterData?.value?.dataAfericaoFim).format('YYYY-MM-DD') || '')
    }
    if (statusFilter && statusFilter != 'Todos') {
      statusFilter.forEach((status: any) => params = params.append('statusAtuais', status.label || status.descricao))
    }
    return this.http.get(this.baseUrl + `/v1/afericoes/servicos-iniciais`, { params });
  }

  getAfericaoInicial(idAfericao: string) {
    return this.http.get(this.baseUrl + `/v1/afericoes/servicos-iniciais/${idAfericao}`);
  }
  getAnaliseAfericoes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/analises`
      , { params }
    );
  }
   getRelatoriosVinculados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string,
    idItemAnalise:string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
  
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/analises/relatorios-vinculados/${idItemAnalise}`
      , { params }
    );
  }
  getDocumentosAssinados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/assinados`
      , { params }
    );
  }
  getDocumentosComprovacao(
    idParametroServicoInicial: string,
    idDocumentoComprovacao: string,
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`
    );
  }
  getDocumentosPendentes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/assinaturas-pendentes`
      , { params }
    );
  }
  postTransicaoStatusAnalise(idParametroServicoInicial: string, formData: any) {
    return this.http.post(this.baseUrl + `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/analises/processar-status`, formData);
  }
  postTransicaoStatus(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/afericoes/servicos-iniciais/processar-status`, formData);
  }
  getTipoAnalises() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-analise?page=0&size=10&sortDirection=asc&sortField=id`
    );
  }
  getDetalhesItemAnalise(idParametroServicoInicial: string, idItemAnalise: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/analises/documentos/${idItemAnalise}`
    );
  }
  getProtocolos(idParametroServicoInicial: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/protocolos`
    );
  }
  assinarDocumento(idParametroServicoInicial: any, idUsuarioAssinante: any,) {
    const data = {
      idUsuarioAssinante: idUsuarioAssinante
    }
    return this.http.post(`${this.baseUrl}/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/assinar`, data)
  }
  deleteAssinaturaPendente(idParametroServicoInicial: any, idDocumentoComprovacao: any) {
    return this.http.delete(`${this.baseUrl}/v1/afericoes/servicos-iniciais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`,)
  }
  getFilterOptions(){
     return this.http.get(
      this.baseUrl + `/v1/afericoes/servicos-iniciais/filtros-status`
    );
  }
}
